import React from 'react';
import PropTypes from 'prop-types';
import Link from '@cotyorg/ccx-atoms/Link';
import { trackBuyEvent } from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/product';
import OptionalSection from '@cotyorg/ccx-utils/js/components/OptionalSection';

const Retailer = ({
  name,
  price,
  trackingPrice,
  buyButtonLabel,
  link,
  inStock,
  outOfStockLabel,
  productTitle,
  categoryTitle = '',
  subcategoryTitle,
  currencyCode,
  sku,
  productSwatch,
  hidePrice,
}) => (
  <li className="product-retailers__list-item align-middle align-justify flex-container">
    <div className="product-retailers__name">{name}</div>
    {inStock ? (
      <>
        <div>
          <OptionalSection
            renderCondition={!hidePrice}
            section={() => (
              <div className="product-retailers__price">{price}</div>
            )}
          />

          <Link
            testAttribute="retailer-link"
            extraClass="product-retailers__button"
            title={buyButtonLabel}
            link={link}
            target="_blank"
            onClick={() =>
              trackBuyEvent({
                productSwatch,
                currencyCode,
                sku,
                productTitle,
                categoryTitle,
                subcategoryTitle,
                name,
                link,
                price: trackingPrice,
              })
            }
          >
            {buyButtonLabel}
          </Link>
        </div>
      </>
    ) : (
      <span className="product-retailers__out-of-stock">{outOfStockLabel}</span>
    )}
  </li>
);

Retailer.propTypes = {
  name: PropTypes.string,
  price: PropTypes.string,
  trackingPrice: PropTypes.string,
  buyButtonLabel: PropTypes.string,
  link: PropTypes.string,
  inStock: PropTypes.bool,
  outOfStockLabel: PropTypes.string,
  productTitle: PropTypes.string,
  categoryTitle: PropTypes.string,
  subcategoryTitle: PropTypes.string,
  currencyCode: PropTypes.string,
  sku: PropTypes.string,
  productSwatch: PropTypes.shape({
    swatches: PropTypes.arrayOf(
      PropTypes.shape({
        sku: PropTypes.string,
        itemName: PropTypes.string,
        skuColor: PropTypes.string,
      })
    ),
  }),
  hidePrice: PropTypes.bool,
};

export default Retailer;
